import { render, staticRenderFns } from "./EPay.vue?vue&type=template&id=28dfd194&scoped=true"
import script from "./EPay.vue?vue&type=script&lang=js"
export * from "./EPay.vue?vue&type=script&lang=js"
import style0 from "./EPay.vue?vue&type=style&index=0&id=28dfd194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dfd194",
  null
  
)

export default component.exports